<template>
  <es-dialog
    :title="$t('发票信息')"
    :visible.sync="visible"
    width="658px"
    :before-close="handleClose"
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <div class="invoice-info">
      <div class="invoice-form">
        <es-form :model="form" :rules="rules" ref="invoiceForm" label-width="106px" label-position="left" :key="isSpecialInvoice">
          <!-- 发票抬头 -->
          <es-form-item :label="$t(`发票抬头`)" prop="title" class="invoice-title">
            <es-input disabled :value="userInfo.name"></es-input>
          </es-form-item>

          <!-- 纳税人识别号 -->
          <es-form-item :label="$t(`纳税人识别号`)" prop="identifyNumber" v-if="isOrg">
            <es-input v-model="form.identifyNumber" :placeholder="$t(`请输入纳税人识别号`)"></es-input>
          </es-form-item>

          <!-- 发票类型 -->
          <es-form-item :label="$t(`发票类型`)" prop="invoiceType" required>
            <es-select v-model="form.invoiceType" :placeholder="$t(`请选择发票类型`)" :disabled="!isOrg">
              <es-option :label="$t(`增值税普通发票`)" :value="1"></es-option>
              <!-- 个人主体不可选增值专用 -->
              <es-option :label="$t(`增值税专用发票`)" :value="2" v-if="isOrg"></es-option>
            </es-select>
          </es-form-item>

          <!-- 开票银行 -->
          <es-form-item :label="$t(`开票银行`)" prop="bank">
            <es-select
              v-model="form.bank"
              filterable
              clearable
              remote
              :placeholder="$t('请选择开票银行')"
              :remote-method="remoteMethod"
              :loading="searchLoading">
              <es-option v-for="item in bankList" :key="item.id" :label="item.subBankName" :value="item.subBankName"></es-option>
            </es-select>
          </es-form-item>

          <!-- 银行账号 -->
          <es-form-item :label="$t(`银行账号`)" prop="bankAccount">
            <es-input
              v-model="form.bankAccount"
              :placeholder="$t(`请输入银行账号`)"
              maxlength="30"
              @input="handleBankAccountInput"></es-input>
          </es-form-item>

          <!-- 开票地址 -->
          <es-form-item :label="$t(`开票地址`)" prop="invoiceAddress">
            <es-input v-model="form.invoiceAddress" :placeholder="$t(`请输入开票地址`)" maxlength="128"></es-input>
          </es-form-item>

          <!-- 开票电话 -->
          <es-form-item :label="$t(`开票电话`)" prop="invoiceTelephone">
            <es-input
              v-model="form.invoiceTelephone"
              :placeholder="$t(`开票电话，例:18899990000 或 0571-12345678-001 或 400-888-8888`)"
              maxlength="128"></es-input>
          </es-form-item>

          <!-- 邮箱地址 -->
          <es-form-item :label="$t('邮箱地址：')" v-if="form.invoiceType === 2 && form.invoiceForm === 1" prop="invoiceEmail">
            <es-input
              v-model="form.invoiceEmail"
              :placeholder="$t(`电子票开具后，我们会直接通过邮件向您发送对应票据`)"
              maxlength="128"></es-input>
          </es-form-item>
        </es-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <es-button @click="handleClose">{{ $t('取 消') }}</es-button>
      <es-button type="primary" @click="handleSubmit">{{ $t('确 定') }}</es-button>
    </span>
  </es-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { $t } from '@/locales'
// 银行账号验证（只允许输入数字）
const validateBankAccount = (rule, value, callback) => {
      if (!/^\d+$/.test(value)) {
    callback(new Error($t('请输入正确的银行账号')))
      } else {
        callback()
      }
    }

    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
    callback(new Error($t('请输入正确的手机号码')))
      } else {
        callback()
      }
    }

    const validateIdentifyNumber = (rule, value, callback) => {
      if (!value?.length) {
        callback(new Error($t('请输入纳税人识别号')))
      } else if (/^[A-Za-z0-9]+$/.test(value)) {
        callback()
      } else {
        callback(new Error($t('请输入数字或字母的组合')))
      }
    }
export default {
  name: 'InvoiceInfo',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    invoiceForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      bankList: [],
      searchLoading: false,
      form: {
        invoiceAddress: '',
        invoiceForm: 1,
        invoiceEmail: '',
        invoiceTelephone: '',
        bank: '',
        invoiceType: '',
        identifyNumber: '',
        bankAccount: '',
      },
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
    }),
    // 是否为增值税专用发票,专用发票需要校验开票信息
    isSpecialInvoice() {
      return this.form.invoiceType === 2
    },
    rules() {
      return {
        identifyNumber: [
          { required: true, message: $t('请输入纳税人识别号'), trigger: 'blur' },
          { validator: validateIdentifyNumber, trigger: 'blur' },
        ],
        bank: [{ required: false, message: $t('请选择开户银行'), trigger: ['blur', 'change'] }],
        bankAccount: [{ required: false, message: $t('请输入银行账号'), trigger: ['blur', 'change'] }],
        invoiceAddress: [{ required: false, message: $t('请输入开票地址'), trigger: ['blur', 'change'] }],
        invoiceTelephone: [
          { required: false, message: $t('请填写开票电话'), trigger: ['blur', 'change'] },
          {
            type: 'string',
            trigger: ['blur', 'change'],
            message: $t('请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888'),
            pattern: /^((?:(?:(\+)|(00))86)?1\d{10})$|^([48]00-?\d{3}-?\d{4})$|^((?:0\d{2,3}-)?(\d{5,8}(-\d{3,5})?))$/,
          },
        ],
        invoiceEmail: [
          { required: this.isSpecialInvoice, message: $t('请输入接收邮箱'), trigger: ['blur', 'change'] },
          {
            type: 'email',
            message: $t('请正确填写接收邮箱'),
            trigger: ['blur', 'change'],
          },
        ],
      }
    },
  },
  watch: {
    visible: {
      handler(v) {
        if (v) {
          this.form = {
            ...this.invoiceForm,
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 关闭弹窗
    handleClose(v) {
      this.$refs.invoiceForm.resetFields()
      this.$emit('closeInvoiceDialog')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.invoiceForm.validate(valid => {
        // 增值税普通发票不校验表单
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    },
    // 获取发票银行账号
    getBankInfoBySubName(subBankName) {
      const self = this
      this.$ajax(this.$url.getBankInfoBySubName(), {
        subBankName,
      })
        .then(res => {
          self.bankList = res.data.list
          self.searchLoading = false
        })
        .catch(() => (self.searchLoading = false))
    },
    // 搜索开户银行
    remoteMethod(query) {
      if (query && query.trim()) {
        this.searchLoading = true
        this.getBankInfoBySubName(query.trim())
      }
    },
    // 银行账户校验，只允许输入数字
    handleBankAccountInput() {
      this.form.bankAccount = this.form.bankAccount.replace(/[^0-9]/g, '')
    },
  },
}
</script>

<style lang="less" scoped>
.invoice-info {
  background: #fff;
  border-radius: 4px;

  .invoice-form {
    max-width: 800px;
    margin: 0 auto;

    /deep/ .es-form-item {
      // margin-bottom: 16px;
      .es-form-item__label {
        font-size: 12px;
      }
      .es-input,
      .es-select {
        width: 100%;
        font-size: 12px;
      }
    }
    .invoice-title {
      /deep/ .es-form-item__label {
        &::before {
          content: '*';
          color: var(--es-color-danger, #f12e10);
          margin-right: 4px;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
